import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Message, Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import CompanyBasicInfoForm from '../../components/forms/companyBasicInfoForm/CompanyBasicInfoForm'
import CompanyBasicInfoView from './CompanyBasicInfoView'
import {
  saveProposalGranteeCompanyBasicInfo,
  saveSubProjectProposalGranteeCompanyBasicInfo,
  updateProposalGranteeCompanyBasicInfo,
  updateSubProjectProposalGranteeCompanyBasicInfo,
} from '../../redux/actions/proposalGranteeBasicInfo'
import {
  saveProposalResponsinatorCompanyBasicInfo,
  saveProposalResponsinatorCompanyBasicInfoSubproject,
  updateProposalResponsinatorCompanyBasicInfo,
  updateProposalResponsinatorCompanyBasicInfoSubproject,
} from '../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../redux/actions/sidebar'
import ButtonPanel from '../ButtonPanel'

export default function CompanyBasicInfo({ schema, isEditAll, ...props }) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject, offerFundedInfoSchema } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors, getValues } =
    useForm()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema)

  const handleSubmitCompanyBasicInfo = async (request, id) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      switch (type) {
        case 'grantee':
          if (id) {
            //update
            response = isSubProject
              ? await updateSubProjectProposalGranteeCompanyBasicInfo(
                  request,
                  projectId,
                  request.id
                )
              : await updateProposalGranteeCompanyBasicInfo(request, projectId, id)
          } else {
            //add new
            response = isSubProject
              ? await saveSubProjectProposalGranteeCompanyBasicInfo(request, projectId)
              : await saveProposalGranteeCompanyBasicInfo(request, projectId)
          }

          break
        case 'responsinator':
          if (id) {
            //update
            response = isSubProject
              ? await updateProposalResponsinatorCompanyBasicInfoSubproject(
                  request,
                  projectId,
                  request.id
                )
              : await updateProposalResponsinatorCompanyBasicInfo(request, projectId, id)
          } else {
            //add new
            response = isSubProject
              ? await saveProposalResponsinatorCompanyBasicInfoSubproject(request, projectId)
              : await saveProposalResponsinatorCompanyBasicInfo(request, projectId)
          }

          break

        default:
          break
      }

      setFormSchema(response)
      onChangeIsEdit(false)
      if (!id) {
        if (isSubProject) {
          await dispatch(getSchemaSubProjectSidebar(projectId))
        } else {
          await dispatch(getSchemaSidebar(projectId))
        }
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    const request = {
      id: formSchema.id,
      idNumber: data.idNumber,
      companyName: data.companyName || '',
      subCompanyName: data.subCompanyName || '',
      telephone: data.telephone || '',
      mobile: data.mobile || '',
      fax: data.fax || '',
      email: data.email || '',
      organizationalType: data.companyType || 0,
      masterOrganizationalBusinessTypeId: data.companyNature?.toString() || '',
      otherOrganizationalBusinessType: data.companyNature == '13' || data.companyNature == '32' ? data.inputOther : '',
    }

    const formData = new FormData()

    data.idCard &&
      data.idCard?.forEach((element) => {
        formData.append('IdCardFile', element.blobFile)
      })

    formData.append('IdNumber', data.idNumber || '')
    formData.append('CompanyName', data.companyName || '')
    formData.append('SubCompanyName', data.subCompanyName || '')
    formData.append('Telephone', data.telephone || '')
    formData.append('Mobile', data.mobile || '')
    formData.append('Fax', data.fax || '')
    formData.append('Email', data.email || '')
    formData.append('OrganizationalType', data.companyType || 0)
    formData.append('MasterOrganizationalBusinessTypeId', data.companyNature?.toString() || '')
    formData.append(
      'OtherOrganizationalBusinessType',
      data.companyNature == '13' || data.companyNature == '32' ? data.inputOther : ''
    )

    // console.log('request', JSON.stringify(request))
    isSubProject
      ? handleSubmitCompanyBasicInfo(request, formSchema.id)
      : handleSubmitCompanyBasicInfo(formData, formSchema.id)
  }

  return (
    <>
      <Panel shaded header={formSchema.title} bordered collapsible defaultExpanded>
        {formSchema?.alertMessages?.map((e) => (
          <Message
            showIcon={e.showIcon}
            type={e.type || 'warning'}
            description={e.message}
            style={{ marginBottom: 10 }}
          />
        ))}

        {isEdit && showCommandButton ? (
          <CompanyBasicInfoForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            offerFundedInfoSchema={offerFundedInfoSchema}
          ></CompanyBasicInfoForm>
        ) : (
          <div>
            <CompanyBasicInfoView data={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.title}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
